// eslint-disable-next-line no-shadow
export enum InstallmentsFeeType {
  ticketPhysicalSale = 'ticketPhysicalSale',
  ticketWebsiteSale = 'ticketWebsiteSale',
  productPhysicalSale = 'productPhysicalSale',
  productWebsiteSale = 'productWebsiteSale',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  ticketPhysicalSaleId = 'ticketPhysicalSaleId',
  ticketPhysicalSaleDebit = 'ticketPhysicalSaleDebit',
  ticketPhysicalSaleCredit = 'ticketPhysicalSaleCredit',
  ticketPhysicalSalePix = 'ticketPhysicalSalePix',
  ticketPhysicalSaleAdministrateTax = 'ticketPhysicalSaleAdministrateTax',
  ticketPhysicalSaleInstallments = 'ticketPhysicalSaleInstallments',
  ticketWebsiteSaleId = 'ticketWebsiteSaleId',
  ticketWebsiteSaleBankSlip = 'ticketWebsiteSaleBankSlip',
  ticketWebsiteSaleCredit = 'ticketWebsiteSaleCredit',
  ticketWebsiteSalePix = 'ticketWebsiteSalePix',
  ticketWebsiteSaleAdministrateTax = 'ticketWebsiteSaleAdministrateTax',
  ticketWebsiteSaleInstallments = 'ticketWebsiteSaleInstallments',
  productPhysicalSaleId = 'productPhysicalSaleId',
  productPhysicalSaleDebit = 'productPhysicalSaleDebit',
  productPhysicalSaleCredit = 'productPhysicalSaleCredit',
  productPhysicalSalePix = 'productPhysicalSalePix',
  productPhysicalSaleAdministrateTax = 'productPhysicalSaleAdministrateTax',
  productPhysicalSaleInstallments = 'productPhysicalSaleInstallments',
  productWebsiteSaleId = 'productWebsiteSaleId',
  productWebsiteSaleBankSlip = 'productWebsiteSaleBankSlip',
  productWebsiteSaleCredit = 'productWebsiteSaleCredit',
  productWebsiteSalePix = 'productWebsiteSalePix',
  productWebsiteSaleAdministrateTax = 'productWebsiteSaleAdministrateTax',
  productWebsiteSaleInstallments = 'productWebsiteSaleInstallments',
}

export interface InstallmentFeeForm {
  installment: number;
  fee: string;
}
